import { useAppTranslation } from "@/utils";
import { PhRCopy } from "@payping/icons";
import { Button, Copy, Flex, Modal, Typography } from "@payping/web-components";
import { FC } from "react";

interface Props {
  open?: boolean;
  onClose: () => void;
}
const GetOrderUploadVideoAndSignaturePageContinueWithSupportedDevices: FC<Props> = ({ onClose, open }) => {
  const { t } = useAppTranslation();
  const windowUrl = window.location.toString();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={t("pay.getOrder.steps.uploadVideoAndSignature.openInSupportedDevices.title")}
      footer={null}
      closable={false}
    >
      <Flex vertical className="tw:w-full" gap={"small"}>
        <Typography.Text type="secondary">
          {t("pay.getOrder.steps.uploadVideoAndSignature.openInSupportedDevices.content")}
        </Typography.Text>
        <Flex className="tw:py-5!" justify="space-between" align="center">
          <Button type="link" icon={<PhRCopy width={14} height={14} />}>
            <Copy text={windowUrl}>
              <Flex gap={"small"} className="tw:dir-ltr!">
                {t("common.copyLink")}
              </Flex>
            </Copy>
          </Button>
          {/* <Button>{t("pay.getOrder.steps.uploadVideoAndSignature.openInSupportedDevices.sendLinkBySMS")}</Button> */}
        </Flex>
      </Flex>
    </Modal>
  );
};

export default GetOrderUploadVideoAndSignaturePageContinueWithSupportedDevices;
